import React from "react";
import "./ProgressTracker.css";

const ProgressTracker = ({ currentStep, status }) => {
  const steps = [
    "Submitted",
      "Screening",
      "Interview",
      "Position Filled",
      "offered",
  ];

  return (
    <div className="progress-container">
      {steps.map((step, index) => {
        let stepClass = "";
        if (index < currentStep) {
          stepClass = "completed";
        } else if (index === currentStep) {
          stepClass = status === "success" ? "success" : "failed";
        }

        return (
          <div key={index} className="progress-step">
            <div className={`circle_score ${stepClass}`}>
              {stepClass === "success" && "✓"}
              {stepClass === "failed" && "✕"}
            </div>
            <p>{step}</p>
            {index < steps.length - 1 && (
              <div className={`line ${index < currentStep ? "active" : ""}`}></div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default ProgressTracker;
